import React, { useEffect, useState } from "react"
import { TAhealth } from "../services/healthAPI"
import { useNavigate } from "react-router-dom"
import { getErrorStatus } from "../types/error"

const HealthCheck = () => {
  const navigate = useNavigate()
  const [isHealthy, setIsHealthy] = useState(false)

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await TAhealth()
        setIsHealthy(response.status === "UP")
      } catch (error) {
        if (getErrorStatus(error) === 401) {
          navigate("/login")
        }
        setIsHealthy(false)
      }
    }

    checkHealth()
  }, [])

  return (
    <div
      data-testid="health-check-wrapper"
      className="health-check-wrapper flex flex-row justify-center items-center text-center pr-3"
    >
      <p className="mr-2">Server Status:</p>
      <div
        data-testid="health-indicator"
        className={`w-3 h-3 rounded-full ${isHealthy ? "bg-green-500" : "bg-red-500"}`}
      />
    </div>
  )
}

export default HealthCheck
